import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Dialog } from "primereact/dialog";
import { createBrowserHistory } from "history";
import IdleTimer from "react-idle-timer";
import TimeoutModal from "./TimeoutModal";
import { Http } from "../src/utils/Http";
import * as Constants from "../src/containers/pages/Constants/ConstantValues";
import "./AppTopbar.css";
import visacareLogo from "../src/assets/images/Visacare_Images/visacare_logo.svg";
import visacareName from "../src/assets/images/Visacare_Images/visacare_name_1.svg";
import alerticon from "../src/assets/images/Visacare_Images/RiAlertLine.svg";
import menuIcon from "../src/assets/images/Visacare_Images/new_menu.svg";
import signoutImage from "../src/assets/images/Visacare_Images/logout.svg";
import { getPageTitle } from "../src/containers/pages/Constants/ConstantValues";

interface AppProps {
  onToggleMenu: React.MouseEventHandler;
  isLogged?: boolean;
}

interface AppState {
  items: Array<{}>;
  userName: string;
  userfirstName: string;
  userSecondName: string;
  lastName: string;
  middleName: string;
  companyname: string;
  dateofbirth: Date;
  role: string;
  userId: string;
  isAdmin: boolean;
  isSixYearsStayDataDialog: boolean;
  openDialog: boolean;
  addOpenDialog: boolean;
  profileImage: any;
  alertMessage: any;
  showModal: boolean;
  profileOpenDialog: boolean;
  endDate: any;
  isOnlineDialaog: boolean;
}
const iPAddress = Constants.IpAddress;

console.log(" App Top Bar " + new Date());
export class AppTopbar extends React.Component<AppProps, AppState> {
  private menu!: Menu | null;
  private isSixYearsStayDataDialog = false;
  idleTimer: any;
  logoutTimer: any;
  history = createBrowserHistory();
  endDate = new Date();
  constructor(props: AppProps) {
    super(props);

    this.handleOpenDialog = this.handleOpenDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleAddOpenDialog = this.handleAddOpenDialog.bind(this);
    this.handleAddCloseDialog = this.handleAddCloseDialog.bind(this);
    this.handleProfileOpenDialog = this.handleProfileOpenDialog.bind(this);
    this.handleProfileCloseDialog = this.handleProfileCloseDialog.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleInputUserChange = this.handleInputUserChange.bind(this);
    this.state = {
      isAdmin: false,
      isSixYearsStayDataDialog: false,
      openDialog: false,
      addOpenDialog: false,
      userName: "",
      userId: "",
      companyname: "",
      lastName: "",
      middleName: "",
      dateofbirth: null,
      userfirstName: "",
      userSecondName: "",
      role: "",
      profileImage: "",
      alertMessage: "",
      isOnlineDialaog: false,
      showModal: false,
      endDate: new Date(),
      profileOpenDialog: false,
      items: [
        {
          icon: "pi pi-fw pi-file",
          items: [
            {
              label1: "",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark",
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video",
                },
              ],
            },
            {
              label: "",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark",
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video",
                },
              ],
            },
            {
              label: "",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark",
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video",
                },
              ],
            },
            {
              label: "",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark",
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video",
                },
              ],
            },
          ],
        },
      ],
    };
  }

  componentWillMount() {
    const loggedInString = localStorage.getItem("AUTHDATA");
    var obj = JSON.parse(localStorage.getItem("AUTHDATA"));
    var obj1 = JSON.parse(localStorage.getItem("TOKENAUTH"));
    if (Constants.tokenValid(obj.loginhistory.login_date, obj1.expiresIn)) {
      obj.loginhistory.login_date = new Date();
      window.localStorage.setItem("AUTHDATA", JSON.stringify(obj));
    } else {
      this.clickLogout();
    }
    if (loggedInString) {
      const loggedInData = JSON.parse(loggedInString);
      var alertMessageDispaly = "";

      if (loggedInData.userDetails[0].companyAutoid !== null) {
        if (
          loggedInData.userDetails[0].companyAutoid.companyautoid === "IMMLAWS"
        ) {
          alertMessageDispaly = "";
        } else if (
          loggedInData.userDetails[0].companyAutoid.transactionDetailsAdded ==
          null ||
          loggedInData.userDetails[0].companyAutoid.transactionDetailsAdded !==
          true
        ) {
          alertMessageDispaly =
            "Please Add Payment Method before creating New Employee/Case";
        }
      }
      // alert(JSON.stringify(loggedInData));
      if (!loggedInData && loggedInData.loggedStatus === 1) {
        window.localStorage.setItem("AUTHDATA", "");
        //window.location.href = "/";
      }
      //var currentLocation = window.location.pathname;
      // console.log(JSON.stringify(loggedInData));
      this.setState({
        userName:
          loggedInData.userProfile[0].userautoid.personautoid.first_name,
      });
      this.setState({
        userSecondName:
          loggedInData.userProfile[0].userautoid.personautoid.second_name,
      });
      this.setState({
        role: loggedInData.userProfile[0].roleFkId.roleName,
      });
      this.setState({
        userId: loggedInData.userProfile[0].userautoid.userId,
      });
      this.setState({
        isAdmin: loggedInData.userProfile[0].roleFkId.roleId === 1,
      });
      this.setState({
        middleName:
          loggedInData.userProfile[0].userautoid.personautoid.middle_name,
      });
      this.setState({
        lastName: loggedInData.userProfile[0].userautoid.personautoid.last_name,
      });
      this.setState({
        dateofbirth: loggedInData.userProfile[0].userautoid.personautoid.dob,
      });
      if (loggedInData.userDetails[0].companyAutoid !== null) {
        this.setState({
          companyname:
            loggedInData.userProfile[0].userautoid.companyAutoid.companyname,
        });
      }
      this.setState({
        isSixYearsStayDataDialog: false,
      });
      this.setState({
        profileImage:
          loggedInData.userProfile[0].userautoid.personautoid.first_name.charAt(
            0
          ) +
          loggedInData.userProfile[0].userautoid.personautoid.last_name.charAt(
            0
          ),
      });

      this.setState({
        alertMessage: alertMessageDispaly,
      });
    } else {
      window.location.href = "/login";
    }
  }

  // The sidebar's Sign Out icon asks the topbar to show the same confirmation
  componentDidMount() {
    window.addEventListener("vc-open-logout", this.handleAddOpenDialog);
  }

  componentWillUnmount() {
    window.removeEventListener("vc-open-logout", this.handleAddOpenDialog);
  }

  onIdle = () => {
    this.togglePopup();
    this.logoutTimer = setTimeout(() => {
      this.clickLogout();
    }, 1000 * 5 * 1); // 5 seconds
  };

  togglePopup = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleStayLoggedIn = () => {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
      this.logoutTimer = null;
    }
    this.idleTimer.reset();
    this.togglePopup();
  };

  handleLogout = () => {
    this.history.push("/");
  };

  clickLogout() {
    const loggedInString = localStorage.getItem("AUTHDATA");
    if (loggedInString) {
      const loggedInData = JSON.parse(loggedInString);
      //alert(JSON.stringify(loggedInData.loginhistory.userId));
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer my-token",
          "My-Custom-Header": "foobar",
        },
        body: JSON.stringify({
          userId: loggedInData.userProfile[0].userautoid.userId,
        }),
      };

      fetch(iPAddress + "/api2/api/logout", requestOptions)
        .then((response) => response.json())
        .then((json) => { })
        .then((data) =>
          this.setState({ userId: loggedInData.loginhistory.userId })
        );
    }
    window.localStorage.setItem("AUTHDATA", "");
    window.localStorage.setItem("LOGINLAWFIRMDATA", null);
    window.location.href = "/login";
    // Call Backend method for logout userid
  }

  clickChange() {
    // alert(JSON.stringify(this.state.userId));
    window.location.href = "/staticui/setpassword";
  }

  showmenu() {
    this.isSixYearsStayDataDialog = true;
  }
  handleOpenDialog() {
    this.setState({
      openDialog: true,
    });
  }
  handleI9Dashboard() {
    window.location.href = "/visaCareI9Dashboard";
  }
  handleInputChange = (e) => {
    if (e.value.code === "PR") {
      this.handleOpenDialog();
    } else if (e.value.code === "LO") {
      this.handleAddOpenDialog();
    }
  };
  handleCloseDialog() {
    this.setState({
      openDialog: false,
    });
  }
  handleAddOpenDialog() {
    this.setState({
      openDialog: false,
      addOpenDialog: true,
    });
  }
  handleAddCloseDialog() {
    this.setState({
      addOpenDialog: false,
    });
    this.setState({
      isOnlineDialaog: false,
    });
  }

  handleProfileCloseDialog() {
    this.setState({
      profileOpenDialog: false,
    });
  }
  handleProfileOpenDialog() {
    this.setState({
      profileOpenDialog: true,
    });
    this.setState({
      openDialog: false,
    });
  }

  handlePageChange = () => {
    let accountUser = {
      userId: this.state.userId,
      first_Name: this.state.userName,
      last_Name: this.state.lastName,
      status: "Active",
    };
    this.setState({ profileOpenDialog: false });
    Http.axios()
      .post("api/updatePersionProfileData", accountUser)
      .then((e) => {
        alert("Your profile details has been updated successfully");
      });
  };

  handleInputUserChange = (property) => {
    this.setState({ userName: property.target.value });
  };

  handleInputLastChange = (property) => {
    this.setState({ lastName: property.target.value });
  };

  render() {
    const { showModal } = this.state;

    return (
      <header className="header-container-topbar">
        <section className="logo-sectionnew" aria-label="Logo">
          <div className="logo-container">
            <img
              alt="VisaCare Logo"
              src={visacareLogo}
              className="visacare_logo1Anew"
            />
          </div>
          <div className="menu-icons">
            <img alt="Menu" src={menuIcon} className="menu_elementnew" />
          </div>
          <h1 className="titleTextnew">
            {getPageTitle(window.location.pathname)}
          </h1>
        </section>
        <aside
          className="profile-sectionnew"
          aria-label="User Info"
          onClick={this.handleOpenDialog}
        >
          <p
            className="logo-divider-vertical"
            style={{ marginBottom: "unset" }}
          >
            {this.state.companyname}
          </p>
          <div className="profile-display" title="Profile">
            {this.state.profileImage ? (
              <span className="name_short_logonew">
                {this.state.profileImage}
              </span>
            ) : (
              <span className="name_short_logonew">
                <i className="pi pi-user" style={{ fontSize: "16px" }}></i>
              </span>
            )}
          </div>
          <div className="profile-text-details" style={{ marginLeft: "-13px" }}>
            <div className="roleTypenew" style={{ textAlign: "start" }}>
              {this.state.role}
            </div>
            <div className="reoleEmailnew" style={{ textAlign: "start" }}>
              {this.state.userId}
            </div>
          </div>
        </aside>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          stopOnIdle={true}
          onIdle={this.onIdle}
          timeout={1000 * 60 * 20}
        />

        <TimeoutModal
          showModal={showModal}
          togglePopup={this.togglePopup}
          handleStayLoggedIn={this.handleStayLoggedIn}
          clickLogout={this.clickLogout}
        />

        <Dialog
          visible={this.state.openDialog}
          className="topbar-profile-dialog"
          modal={false}
          showHeader={false}
          onHide={() =>
            this.setState({
              openDialog: false,
            })
          }
        >
          <div className="tpm">
            <div className="tpm-header">
              <span className="tpm-avatar">
                {this.state.profileImage ? (
                  this.state.profileImage
                ) : (
                  <i className="pi pi-user"></i>
                )}
              </span>
              <div className="tpm-identity">
                <div className="tpm-name" title={this.state.userName + " " + this.state.lastName}>
                  {this.state.userName + " " + this.state.lastName}
                </div>
                <div className="tpm-email" title={this.state.userId}>
                  {this.state.userId}
                </div>
              </div>
              <button
                type="button"
                className="tpm-close"
                aria-label="Close"
                onClick={() => this.setState({ openDialog: false })}
              >
                <i className="pi pi-times"></i>
              </button>
            </div>
            <div className="tpm-divider"></div>
            <div className="tpm-item" role="button" tabIndex={0}>
              <i className="pi pi-cog"></i>
              <span>Account</span>
            </div>
            <div
              className="tpm-item"
              role="button"
              tabIndex={0}
              onClick={this.handleProfileOpenDialog}
              onKeyDown={(e) => e.key === "Enter" && this.handleProfileOpenDialog()}
            >
              <i className="pi pi-user"></i>
              <span>Profile</span>
            </div>
            <div
              className="tpm-item"
              role="button"
              tabIndex={0}
              onClick={() => window.location.href = "/staticui/setpassword"}
              onKeyDown={(e) => { if (e.key === "Enter") window.location.href = "/staticui/setpassword"; }}
            >
              <i className="pi pi-key"></i>
              <span>Change Password</span>
            </div>
            <div className="tpm-divider"></div>
            <div
              className="tpm-item tpm-item-danger"
              role="button"
              tabIndex={0}
              onClick={this.handleAddOpenDialog}
              onKeyDown={(e) => e.key === "Enter" && this.handleAddOpenDialog()}
            >
              <img className="tpm-signout-icon" alt="" src={signoutImage} />
              <span>Sign Out</span>
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={this.state.addOpenDialog}
          showHeader={false}
          modal={true}
          className="tpm-logout-dialog"
          onHide={() =>
            this.setState({
              addOpenDialog: false,
            })
          }
        >
          {this.state.addOpenDialog && (
            <div className="tpm-logout-box">
              <div className="tpm-logout-icon">
                <i className="pi pi-sign-out"></i>
              </div>
              <h3 className="tpm-logout-title">Sign Out</h3>
              <p className="tpm-logout-text">Are you sure you want to logout?</p>
              <div className="tpm-logout-actions">
                <Button
                  className="cancel_text_topbar"
                  label="No"
                  icon="pi pi-times"
                  onClick={this.handleAddCloseDialog}
                />
                <Button
                  className="addname_text_topbar"
                  label="Yes"
                  icon="pi pi-check"
                  onClick={this.clickLogout}
                />
              </div>
            </div>
          )}
        </Dialog>

        <Dialog
          header={"User Details "}
          visible={this.state.profileOpenDialog}
          className="dial-head"
          modal={true}
          onHide={() => this.setState({ profileOpenDialog: false })}
        >
          {this.state.profileOpenDialog && (
            <div className="p-grid card-w-title">
              <div id="removePadding" className="p-col-12">
                <div className="p-grid">
                  <div className="displ">
                    <div id="removePadding" className="p-col-12 p-md-3 width40">
                      First Name :
                    </div>
                    <div id="removePadding" className="p-col-12 p-md-3 width60">
                      <InputText
                        id="stateUserName"
                        name="stateUserName"
                        onChange={this.handleInputUserChange}
                        value={this.state.userName}
                        required
                      />
                    </div>
                  </div>
                  <div className="displ">
                    <div id="removePadding" className="p-col-12 p-md-3 width40">
                      Last Name :
                    </div>
                    <div id="removePadding" className="p-col-12 p-md-3 width60">
                      <InputText
                        id="stateLastName"
                        name="stateLastName"
                        onChange={this.handleInputLastChange}
                        value={this.state.lastName}
                        required
                      />
                    </div>
                  </div>
                  <div id="removePadding" className="p-col-12 p-md-4"></div>
                  <div
                    id="removePadding"
                    style={{ textAlign: "center" }}
                    className="p-col-12 p-md-4"
                  >
                    <Button
                      icon="pi pi-save"
                      label="Save"
                      onClick={this.handlePageChange}
                      style={{ width: "fit-content" }}
                    />
                  </div>
                  <div id="removePadding" className="p-col-12 p-md-4"></div>
                </div>
              </div>
            </div>
          )}
        </Dialog>

        <Dialog
          visible={this.state.isOnlineDialaog}
          showHeader={false}
          modal={true}
          onHide={() => this.setState({ isOnlineDialaog: false })}
        >
          {this.state.isOnlineDialaog && (
            <div id="removePadding">
              <p className="dialogSign" style={{ fontSize: "15px" }}>
                Your Internet connection is Lost !!!. Do you want to Reload?
              </p>
              <p>
                <button onClick={this.clickLogout} className="dialogSubmit">
                  Yes
                </button>
                <button
                  onClick={this.handleAddCloseDialog}
                  className="dialogSubmit"
                >
                  No
                </button>
              </p>
            </div>
          )}
        </Dialog>
      </header>
    );
  }
}
